import { Component, DestroyRef, inject, OnInit, DOCUMENT } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as PatientActions from './state/patient.actions';
import { Store } from '@ngrx/store';
import { Location } from '@angular/common';
import { selectCurrentLanguage } from './state/patient.selectors';
import { distinctUntilChanged } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Languages, TextDirection } from 'Shared/app/constants/languages.constants';

@Component({
  selector: 'wfp-app',
  templateUrl: 'app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit {
  readonly #destroyRef = inject(DestroyRef);
  readonly #router = inject(Router);
  readonly #translateService = inject(TranslateService);
  readonly #store = inject(Store);
  readonly #location = inject(Location);
  #document = inject<Document>(DOCUMENT);

  environment: string;
  router: string;
  private readonly defaultLanguage = Languages.Swedish.resource;

  ngOnInit(): void {
    this.#store
      .select(selectCurrentLanguage)
      .pipe(
        distinctUntilChanged((previous, current) => {
          return previous.currentLanguage === current.currentLanguage;
        }),
        takeUntilDestroyed(this.#destroyRef)
      )
      .subscribe((languageInfo) => {
        if (languageInfo?.currentLanguage) {
          this.#translateService.use(languageInfo.currentLanguage);

          this.#document.documentElement.dir = languageInfo.isRtl ? TextDirection.RTL : TextDirection.LTR;
        }
      });

    this.#translateService.setFallbackLang(this.defaultLanguage);
    this.#translateService.use(this.defaultLanguage);

    this.#store.dispatch(PatientActions.setAntiforgery());
    this.router = this.#router.url;
    this.environment = environment.wfEnvironment?.toLowerCase();
    if (!this.#location.path().includes('loginType=sso')) {
      this.#store.dispatch(PatientActions.loadSessionFromServer());
    }
    this.#store.dispatch(PatientActions.loadSupportedLanguagesFromServer());
  }
}
